import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import { ViajesService } from '../../../services/viajes.service';
import { UnidadesService } from '../../../services/unidades.service';
import { CatalogosService } from '../../../services/catalogos.service';
import { Observable } from 'rxjs/Observable';
@Component({
  selector: 'crear-evento',
  templateUrl: './crear-evento.components.html'
})

export class CrearEventoComponent implements OnInit {
	
	constructor(
        private unidadesService:UnidadesService,
        private viajesService: ViajesService,
		private usuariosService: UsuariosPersonalService,
        private route:Router,
        private catalogoService:CatalogosService){

	}

    public inicioTimeStamp:any;
    public finTimeStamp:any;
    public viaje:object={};
    public unidadesOcupadas:Observable<any>;
    public unidades:Observable<any>;
    public unidadesDisponibles:Array<any>=[];
    public tiposDeUnidad:any;
    public tipoDeUnidad='';

	ngOnInit(){
        this.tiposDeUnidad= this.catalogoService.obtenerTiposDeUnidad().valueChanges().map(unidadesBD=>{
            let arregloNuevo=[]
            unidadesBD.forEach(tipo => {
                let $key=tipo
                if(tipo == 'Auto')
                    tipo=tipo+' - Auto'
                if(tipo == 'Lujo')
                    tipo=tipo+' - Sprinter'
                if(tipo == 'Tipo 1')
                    tipo=tipo+' - Toyota'
                if(tipo == 'Tipo 2')
                    tipo=tipo+' - Sprinter'
                arregloNuevo.push({data:tipo,$key:$key})
            });
            return arregloNuevo
        });
    }
    tiempoTimeStamp(origen, tipo){
        if(origen == 'inicio'){
            this.inicioTimeStamp = new Date(this.viaje['inicioViaje']).getTime();
        }else  if(origen == 'fin'){
            this.finTimeStamp = new Date(this.viaje['finViaje']).getTime();
        }
        if(this.inicioTimeStamp && this.finTimeStamp){
            this.unidades = this.unidadesService.obtenerUnidades().snapshotChanges().map(unidadesDB=>{
                let lista=[]
                unidadesDB.forEach((actions)=>{
                    const data = actions.payload.doc.data();
                    const $key = actions.payload.doc.id;
                    if(data.operador != " ")
                        lista.push({ $key,...data  })
                })
            return lista
            })
            this.unidadesOcupadas = this.viajesService.obtenerUnidadesNoDisponibles(this.inicioTimeStamp,this.finTimeStamp);
            this.unidadesDisponibles=[];   
                    
            Observable.zip(
                this.unidades,
                this.unidadesOcupadas
            ).subscribe(arregloUnidades=>{
                console.log(arregloUnidades)
                let arregloCompleto:Array<any>=arregloUnidades[0]
                let arregloOcupadas=arregloUnidades[1]
                arregloOcupadas.forEach((unidad)=>{
                    arregloCompleto = arregloCompleto.filter(function( obj ) {
                        return obj.$key !== unidad.$key;
                    });
                })
                this.unidadesDisponibles =arregloCompleto;
                if(tipo != undefined){
                    this.unidadesDisponibles =   this.unidadesDisponibles.filter(function( obj ) {
                        return obj.tipoDeUnidad == tipo;
                    });
                }
            })
        }
    }
    crearViaje(){
        let objetoViaje = {
            claveConfirmacion: this.viaje['motivo'],
            destino:{
                direccion:this.viaje['destino']
            },
            finDeServicio: this.finTimeStamp,
            idConfirmacion:'Evento',
            idServicio:'Evento',
            inicioDeServicio:this.inicioTimeStamp,
            origen:{
                direccion:this.viaje['origen']
            },
            unidadAsignada:this.viaje['unidad'],
            aprobacionFinanzas:true,
            aprobacionOperador:true
        }
        this.viajesService.crearEventoViaje(objetoViaje).then(res=>{
            this.viaje={}
            alert('Evento creado exitosamente')
        })
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/crear-evento-linea-de-tiempo/crear-evento.components.ts